import { render, staticRenderFns } from "./userProjects.vue?vue&type=template&id=acd760ca&"
import script from "./userProjects.vue?vue&type=script&lang=js&"
export * from "./userProjects.vue?vue&type=script&lang=js&"
import style0 from "./userProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports